/*
 * Copyright 2026 Hypergiant Galactic Systems Inc. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import { clsx } from '@accelint/design-foundation/lib/utils';
import { Icon } from '../icon';
import styles from './styles.module.css';
import type { IconProps } from '../icon/types';

/**
 * TreeItemPrefixIcon - Icon displayed before the tree item label
 *
 * @example
 * ```tsx
 * <TreeItemContent>
 *   <TreeItemPrefixIcon><Folder /></TreeItemPrefixIcon>
 *   <TreeItemLabel>My Documents</TreeItemLabel>
 * </TreeItemContent>
 * ```
 *
 * @param props - {@link IconProps}
 * @param props.children - Icon element to render.
 * @param props.className - CSS class for the icon container.
 * @returns The rendered TreeItemPrefixIcon component.
 */
export function TreeItemPrefixIcon({ children, className }: IconProps) {
  return <Icon className={clsx(styles.icon, className)}>{children}</Icon>;
}
